import clsx from "clsx";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { useEditorInterface } from "../App";

const MenuTrigger = ({
  className = "",
  children,
  onToggle,
  title,
  ...rest
}: {
  className?: string;
  children: React.ReactNode;
  onToggle?: () => void;
  title?: string;
} & Omit<
  React.ComponentProps<typeof DropdownMenuPrimitive.Trigger>,
  "children"
>) => {
  const editorInterface = useEditorInterface();
  const classNames = clsx(
    `dropdown-menu-button ${className}`,
    "zen-mode-transition",
    {
      "dropdown-menu-button--mobile": editorInterface.formFactor === "phone",
    },
  ).trim();
  return (
    <DropdownMenuPrimitive.Trigger asChild>
      <button
        className={classNames}
        onClick={onToggle}
        type="button"
        data-testid="dropdown-menu-button"
        title={title}
        {...rest}
      >
        {children}
      </button>
    </DropdownMenuPrimitive.Trigger>
  );
};

export default MenuTrigger;
MenuTrigger.displayName = "DropdownMenuTrigger";
